import React from "react"
import * as S from "./Styled"
import ReactDOM from "react-dom"
import { CloseIcon } from "./CloseIcon"

const LightBoxComponent = ({ onClose, children, title }) => {
  return (
    <S.LightBoxWrapper>
      <S.MaskLayer onClick={onClose}></S.MaskLayer>
      <S.HeaderLayer>
        {title}
        <CloseIcon onClose={onClose} />
      </S.HeaderLayer>
      <S.ContentLayer onClick={onClose}>{children}</S.ContentLayer>
    </S.LightBoxWrapper>
  )
}

export const LightBox = props =>
  ReactDOM.createPortal(<LightBoxComponent {...props} />, document.body)
